// @ts-nocheck
import { DELHI_CORDINATES } from "@Services/constants";
import { validImageTypes } from "../../cubeComponent/constants/globalVariable";
import get from "lodash/get";

export const getProjectWorkspacesListPageUrl = (projectId: string) =>
  `/project/${projectId}/Workspaces?projectId=${projectId}`;

export const getProjectRiskManagementListPageUrl = (projectId: string) =>
  `/project/${projectId}/riskManagement?projectId=${projectId}`;

export const getCustomModulePageUrl = (moduleId: string, selectedTab: string) =>
  `/portalSettings/formsAndFields?selectedCategory=${moduleId}&selectedTab=${selectedTab}`;

export const getAllNotificationPageUrl = ({ section, module, ticketId, supportType, referrerUrl }: any) => {
  const searchParams = new URLSearchParams("");

  const url = `/notifications`;
  if (section) {
    searchParams.set("section", section);
  }
  if (supportType) {
    searchParams.set("supportType", supportType);
  }
  if (ticketId) {
    searchParams.set("ticketId", ticketId);
  }
  if (module) {
    searchParams.set("module", module);
  }
  if (referrerUrl) {
    searchParams.set("referrerUrl", referrerUrl);
  }

  return `${url}?${searchParams.toString()}`;
};

export const getPortalSettingsTabUrl = (tab: string) => `/portalSettings/${tab}`;

export const getProjectWorkspacePageUrl = (
  projectId: string,
  spaceId: string,
  spaceType: string = "this",
  reviewType?: string,
  path: string[] = [],
) => {
  if (!projectId) {
    throw new Error("ProjectId is undefined");
  }

  const basePath = `/workspace/${spaceId}/explorer`;

  const searchParams = new URLSearchParams();

  searchParams.set("spaceType", spaceType);
  searchParams.set("projectId", projectId);

  if (reviewType) {
    searchParams.set("type", reviewType);
  }

  let url = `${basePath}?${searchParams.toString()}`;

  if (path.length > 0) {
    const folderPath = encodeURIComponent(`/${path.join("/")}`);
    url += `#folderPath=${folderPath}`;
  }

  return url;
};

export const getProjectIssuesPageUrl = (projectId: string) => `/project/${projectId}/issues?projectId=${projectId}`;
export const getProjectFilesPageUrl = (projectId: string) => `/project/${projectId}/listFiles?projectId=${projectId}`;
export const getProjectTransmittalsPageUrl = (projectId: string) =>
  `/project/${projectId}/listTransmittals?projectId=${projectId}`;
export const getSingleTransmittalPageUrl = (projectId: string, transmittalId: string) =>
  `/project/${projectId}/listTransmittals/${transmittalId}?projectId=${projectId}`;
export const getProjectTasksPageUrl = (projectId: string, taskId?: string) => {
  if (taskId) {
    return `/project/${projectId}/listTask/${taskId}?projectId=${projectId}`;
  }
  return `/project/${projectId}/listTask?projectId=${projectId}`;
};
export const getProjectEstimatesPageUrl = (projectId: string) =>
  `/project/${projectId}/EstimateList?projectId=${projectId}`;
export const getEstimatePageUrl = (projectId: string, estimateId: string) =>
  `/project/${projectId}/estimate/${estimateId}?projectId=${projectId}`;

export const getProjectSchedulesPageUrl = (projectId: string) =>
  `/project/${projectId}/scheduleList?projectId=${projectId}`;
export const getProjectFormsPageUrl = (projectId: string, moduleName: string) =>
  `/project/${projectId}/formsList/${moduleName.toLowerCase()}?selectedTab=list&projectId=${projectId}`;
export const getProjectDashboardPageUrl = (projectId: string) =>
  `/project/${projectId}/projectdashboard?projectId=${projectId}`;
export const getPortalProjectsUrl = (projectId: string) => `/portalSettings/projects/${projectId}/projectUsers`;
export const getProjectMailboxPageUrl = (projectId: string) => `/project/${projectId}/mails?projectId=${projectId}`;
export const getProjectReviewsPageUrl = (projectId: string) => `/reviews?projectId=${projectId}`;
export const getEscrowFilesPageUrl = (batchId: string) => `/escrowFiles/${batchId}`;
export const getProjectContractPageUrl = (projectId: string) =>
  `/project/${projectId}/contractsList?projectId=${projectId}`;
export const getReviewUrl = (projectId: string, spaceId: string, reviewId: string) =>
  `/review?reviewId=${reviewId}&spaceId=${spaceId}&projectId=${projectId}`;
export const getPortalFilesUrl = () => `/Files?byPortal=true`;
export const getProjectGeneralClashPageUrl = (projectId: string) =>
  `/project/${projectId}/clashTests?projectId=${projectId}`;
export const getGroupDetailsUrl = (groupId?: string) => {
  if (groupId) {
    return `/portalSettings/groups/${groupId}`;
  } else {
    return `/portalSettings/groups`;
  }
};

export const getChecklistDetailUrl = (checklistId?: string) => {
  if (checklistId) {
    return `/portalSettings/reviewFlowsTemplate/checklists/${checklistId}`;
  }
  return `/portalSettings/reviewFlowsTemplate/checklists`;
};

export const getProjectTemplatesUrl = (projectTemplateId?: string) => {
  if (projectTemplateId) {
    return `/portalSettings/projectTemplates/${projectTemplateId}`;
  } else {
    return `/portalSettings/projectTemplates`;
  }
};
export const getClashDetailsPageUrl = (projectId: string, clashId: string) =>
  `/project/${projectId}/clashDetails/${clashId}?projectId=${projectId}`;

export const getTemplateURL = (props: any) => {
  const { selectedCategory, selectedTab } = props;
  const url = `/portalSettings/formsAndFields`;
  const searchParams = new URLSearchParams();

  if (selectedCategory) {
    searchParams.set("selectedCategory", selectedCategory.toLowerCase());
  }
  if (selectedTab) {
    searchParams.set("selectedTab", selectedTab);
  }
  return `${url}?${searchParams.toString()}`;
};
export const getCreateTaskPageUrl = (projectId: string, extraSearchParams?: string) => {
  if (extraSearchParams) {
    return `/project/${projectId}/createTasks?projectId=${projectId}&${extraSearchParams}`;
  }
  return `/project/${projectId}/createTasks?projectId=${projectId}`;
};
export const getEditTaskPageUrl = (projectId: string, taskId: string, extraSearchParams?: string) => {
  if (extraSearchParams) {
    return `/project/${projectId}/editTask/${taskId}?projectId=${projectId}&${extraSearchParams}`;
  }
  return `/project/${projectId}/editTask/${taskId}?projectId=${projectId}`;
};

export const getEstimateUrl = (props: any) => {
  const { estimateList, projectId, estimateId, versionId } = props;
  const searchParams = new URLSearchParams("");
  let location = `/project/${projectId}`;
  if (estimateList) {
    location += "/EstimateList";
  }
  if (estimateId) {
    location += `/estimate/${estimateId}`;

    if (versionId) {
      location += `/version/${versionId}`;
    }
  }

  searchParams.set("projectId", projectId);

  return `${location}?${searchParams.toString()}`;
};

export const getScheduleUrl = (props: any) => {
  const { projectId, scheduleId, selectedTab = "Gantt" } = props;
  const searchParams = new URLSearchParams("");
  const location = `/project/${projectId}/schedule/${scheduleId}/scheduleDetails`;

  searchParams.set("selectedTab", selectedTab);
  searchParams.set("projectId", projectId);

  return `${location}?${searchParams.toString()}`;
};

export const getContractListUrl = (url: any, props: any) => {
  const { projectId, selectedTab } = props;
  const searchParams = new URLSearchParams("");

  if (projectId) {
    searchParams.set("projectId", projectId);
  }
  if (selectedTab) {
    searchParams.set("selectedTab", selectedTab);
  }

  return `${url}?${searchParams.toString()}`;
};

export const getProjectSettingsPageUrl = ({ projectId, tab, extraSearchParams = {} }: any) => {
  const params = new URLSearchParams({
    projectId,
    tab,
    ...extraSearchParams,
  });
  return `/project/${projectId}/setting?${params.toString()}`;
};

export const getContractDetailUrl = (props: any) => {
  const { selectedTab, projectId, contractId, versionId } = props;

  const url = `/project/${projectId}/contract/${contractId}`;
  const searchParams = new URLSearchParams("");

  if (projectId) {
    searchParams.set("projectId", projectId);
  }
  if (selectedTab) {
    searchParams.set("selectedTab", selectedTab);
  }
  if (versionId) {
    searchParams.set("versionId", versionId);
  }

  return `${url}?${searchParams.toString()}`;
};

export const getFormsListUrl = (props: any) => {
  const { selectedTab, projectId, resourceType } = props;

  const url = `/project/${projectId}/formsList/${resourceType?.toLowerCase()}`;
  const searchParams = new URLSearchParams("");

  if (projectId) {
    searchParams.set("projectId", projectId);
  }
  if (selectedTab) {
    searchParams.set("selectedTab", selectedTab);
  }

  return `${url}?${searchParams.toString()}`;
};
export const getFormsTemplateUrl = (props: any) => {
  const { templateId, resourceType } = props;
  return `/portalSettings/formsAndFields/${templateId}/${resourceType?.toLowerCase()}`;
};

const chr = (codePt: any) => {
  if (codePt > 0xffff) {
    codePt -= 0x10000;
    return String.fromCharCode(0xd800 + (codePt >> 10), 0xdc00 + (codePt & 0x3ff));
  }
  return String.fromCharCode(codePt);
};

export const charToNum = (alpha: any) => {
  alpha = String(alpha).toUpperCase();
  let index = 0;
  for (let i = 0; ; i++) {
    if (alpha == numToChar(i)) {
      index = i;
      break;
    }
  }
  return index;
};

export const numToChar: any = (number: any) => {
  const numeric = (number - 1) % 26;
  const letter = chr(65 + numeric);
  const number2 = parseInt((number - 1) / 26);
  if (number2 > 0) {
    return numToChar(number2) + letter;
  }
  return letter;
};

export const toRoman = (number: any) => {
  let num = Math.floor(number);
  let val;
  let s = "";
  let i = 0;
  const v = [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1];
  const r = ["M", "CM", "D", "CD", "C", "XC", "L", "XL", "X", "IX", "V", "IV", "I"];

  function toBigRoman(n) {
    let ret = "";
    let n1 = "";
    let rem = n;
    while (rem > 1000) {
      let prefix = "";
      let suffix = "";
      let n = rem;
      const s = `${rem}`;
      let magnitude = 1;
      while (n > 1000) {
        n /= 1000;
        magnitude *= 1000;
        prefix += "(";
        suffix += ")";
      }
      n1 = Math.floor(n);
      rem = s - n1 * magnitude;
      ret += prefix + n1.toRoman() + suffix;
    }
    return ret + rem.toRoman();
  }

  if (number - num || num < 1) num = 0;
  if (num > 3999) return toBigRoman(num);

  while (num) {
    val = v[i];
    while (num >= val) {
      num -= val;
      s += r[i];
    }
    ++i;
  }
  return s;
};

export const fromRoman = (roman, accept) => {
  const s = roman.toUpperCase().replace(/ +/g, "");
  const L = s.length;
  let sum = 0;
  let i = 0;
  let next;
  let val;
  const R = {
    M: 1000,
    D: 500,
    C: 100,
    L: 50,
    X: 10,
    V: 5,
    I: 1,
  };

  function fromBigRoman(rn) {
    let n = 0;
    let x;
    let n1;
    let S;
    const rx = /(\(*)([MDCLXVI]+)/g;

    while ((S = rx.exec(rn)) != null) {
      x = S[1].length;
      n1 = Number.fromRoman(S[2]);
      if (isNaN(n1)) return NaN;
      if (x) n1 *= Math.pow(1000, x);
      n += n1;
    }
    return n;
  }

  if (/^[MDCLXVI)(]+$/.test(s)) {
    if (s.indexOf("(") == 0) return fromBigRoman(s);

    while (i < L) {
      val = R[s.charAt(i++)];
      next = R[s.charAt(i)] || 0;
      if (next - val > 0) val *= -1;
      sum += val;
    }
    if (accept || toRoman(sum) === s) return sum;
  }
  return NaN;
};

function getNumberFromNumberSystem(value, fromNumberSystem) {
  if (fromNumberSystem == 0) {
    return value;
  }

  if ([1, 2].includes(fromNumberSystem)) {
    return charToNum(value);
  }

  if ([3, 4].includes(fromNumberSystem)) {
    return fromRoman(value);
  }
}

export function getSymbolForNumber(number, toNumberSystem, fromNumberSystem) {
  let convertedNumber = number;

  if (fromNumberSystem) {
    convertedNumber = getNumberFromNumberSystem(number, fromNumberSystem);
  }

  if (toNumberSystem == 1) {
    return numToChar(convertedNumber).toLowerCase();
  }

  if (toNumberSystem == 2) {
    return numToChar(convertedNumber).toUpperCase();
  }

  if (toNumberSystem == 3) {
    return toRoman(convertedNumber).toLowerCase();
  }

  if (toNumberSystem == 4) {
    return toRoman(convertedNumber).toUpperCase();
  }

  return number;
}

export function getNumberBasedOnSettings({
  value,
  decimalPlaces,
  digitGrouping,
  largeNumber,
}: {
  value: number;
  decimalPlaces: number;
  digitGrouping: string;
  largeNumber: string;
}) {
  if (!value) {
    return value;
  }

  let symbol;
  let factor = 1;
  if (largeNumber === "KMB") {
    if (value >= 1000000000) {
      factor = 1000000000;
      symbol = "B";
    } else if (value >= 1000000) {
      factor = 1000000;
      symbol = "M";
    } else if (value >= 1000) {
      factor = 1000;
      symbol = "K";
    }
  } else if (largeNumber === "LCr") {
    if (value >= 10000000) {
      factor = 10000000;
      symbol = "Cr";
    } else if (value >= 100000) {
      factor = 100000;
      symbol = "L";
    }
  }

  value = value / factor;
  let returnValue: string | number = parseFloat(value.toFixed(decimalPlaces));

  if (["Indian", "International"].includes(digitGrouping)) {
    const style = digitGrouping === "Indian" ? "en-IN" : "en-US";
    returnValue = new Intl.NumberFormat(style, { maximumFractionDigits: decimalPlaces }).format(value);
  } else {
    returnValue = String(returnValue);
  }

  if (symbol) {
    returnValue = returnValue + symbol;
  }
  return returnValue;
}

export const prepareEDN = (projectCustomId, indexAtProjectLevel) => `${projectCustomId}-${indexAtProjectLevel}`;

export const validateAvatar = (e, stateData) => {
  const file = e?.target?.files;
  const fileType = file[0].type;
  const data = stateData;
  if (validImageTypes.includes(fileType) && file && file.length > 0) {
    data.logoObj = file[0];
    data.error.logo = "";
  } else {
    data.error.logo = "Please select jpg, jpeg, png file only.";
  }
  return data;
};

export const getTargetValue = (e) => e.value;

export const getSelectedIndex = (list, compareTo) => {
  let indexReturn = -1;
  list?.map((s, index) => {
    if (s.value === compareTo) {
      indexReturn = index;
    }
  });
  return indexReturn;
};

export function getLocationCoordinates() {
  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const locationCoordinates = [position.coords.latitude, position.coords.longitude];
        resolve(locationCoordinates);
      },
      () => {
        resolve([DELHI_CORDINATES.lat, DELHI_CORDINATES.lng]);
      },
    );
  });
}

export function loadRecaptchaScripts() {
  const script = document.createElement("script");
  script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY}`;
  script.async = false;
  document.body.appendChild(script);
}

export const getTreeViewOfDistinctFileProperties = (
  data,
  eachColumnMetadata = {},
  selectedNodes = [],
  appendToLeafNodes = {},
  appendToNonLeafNodes = {},
  overrideField = false,
) => {
  const generateId = (field) => field.replace(/[^a-zA-Z0-9]/g, "_");

  const columnData = [];
  const nodeMap = new Map(); // path → node reference

  for (const value of data) {
    const rawField = value.field;
    const name = overrideField ? value.label : value.field;

    const rootNode = name.split(".")[0];
    const nameArray = name.split(".").slice(1).join(".").split("/");

    // Ensure root node
    let rootNodeRef = nodeMap.get(rootNode);
    if (!rootNodeRef) {
      let label = "Metadata";
      if (rootNode === "customProperties") label = "Custom Metadata";
      else if (rootNode === "typeProperties") label = "Type Metadata";

      rootNodeRef = {
        field: rootNode,
        label,
        id: generateId(rootNode),
        columns: [],
        ...appendToNonLeafNodes,
        ...eachColumnMetadata,
      };
      columnData.push(rootNodeRef);
      nodeMap.set(rootNode, rootNodeRef);
    }

    // Traverse hierarchy efficiently
    let currentPath = rootNode;
    let parentNode = rootNodeRef;

    for (let i = 0; i < nameArray.length; i++) {
      const part = nameArray[i];
      const isLeaf = i === nameArray.length - 1;
      const fullField = isLeaf ? rawField : `${currentPath}.${part}`;

      let nodeRef = nodeMap.get(fullField);
      if (!nodeRef) {
        nodeRef = {
          field: fullField,
          label: part,
          id: generateId(fullField),
          isChecked: !!selectedNodes.includes(fullField),
          ...(isLeaf ? appendToLeafNodes : appendToNonLeafNodes),
          ...eachColumnMetadata,
        };

        if (!isLeaf) nodeRef.columns = [];
        parentNode.columns.push(nodeRef);
        nodeMap.set(fullField, nodeRef);
      }

      if (!isLeaf) {
        parentNode = nodeRef;
        currentPath = fullField;
      }
    }
  }

  return columnData;
};

export const fileToBase64 = async (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (e) => reject(e);
  });

export function removingElementFromRcDock(child, nonActiveIds) {
  if (child.children?.length > 0) {
    child.children = child.children.filter((child) => removingElementFromRcDock(child, nonActiveIds));
  }
  if (child.tabs) {
    if (child.tabs.length > 1) {
      child.tabs = child.tabs.filter((tab) => !nonActiveIds.includes(tab.id));
      if (nonActiveIds.includes(child.activeId)) {
        if (!child.tabs[0]?.id) {
          return false;
        }
        child.activeId = child.tabs[0].id;
      }
      return true;
    }
    if (nonActiveIds.includes(child.activeId)) {
      return false;
    }
    return true;
  }
  return true;
}

export const getFileListPageUrl = (searchParams: string) => {
  const url = new URLSearchParams();
  if (searchParams) {
    url.set("search", searchParams);
  }
  return `/Files?byPortal=true&${url.toString()}`;
};

export const getProjectPageUrl = (searchParams: string, typeProject: string, viewProject: string) => {
  const url = new URLSearchParams();
  if (searchParams) {
    url.set("search", searchParams);
  }
  url.set("type", typeProject);
  url.set("view", viewProject);
  return `/projects?${url.toString()}`;
};

export const getWorkflowPageUrl = (typeWorkflow: string) => {
  const url = new URLSearchParams(window.location.search);
  url.set("type", typeWorkflow);

  const currentPath = window.location.pathname;
  return `${currentPath}?${url.toString()}`;
};

export function isValidJSON(str: string) {
  try {
    JSON.parse(str);
    return true;
  } catch (_error) {
    return false;
  }
}

export const getReviewPageUrl = (typeReview, currentSearchParams, currentPathname) => {
  const urlParams = new URLSearchParams(currentSearchParams);
  urlParams.set("type", typeReview);

  return `${currentPathname}?${urlParams.toString()}`;
};

export const getCustomFields = (formTemplate = []) => {
  const customFields = {};
  formTemplate?.forEach((section: any) => {
    section.questionFields.forEach((field: any) => {
      if (field.answer && field.answer.value) {
        customFields[field._id] = field.answer.value;
      }
    });
  });
  return customFields;
};

export const isFileNomenclatureCorrect = (name, fileNomenclature: any = {}) => {
  let fileName = name || "";
  if (!name || !fileNomenclature?.fields) {
    return true;
  }
  if (name.includes(".")) {
    fileName = name.split(".");
    fileName.pop();
  } else {
    fileName = [fileName];
  }
  fileName = fileName.join(".").split(fileNomenclature.separator);

  if (fileNomenclature.fields.length) {
    return fileNomenclature.fields.every((rule, index) => {
      let output = false;

      if ((rule.type == "text" || rule.type == "number") && !rule.allowedCharacters) {
        return true;
      }

      const textCondition = rule.type == "text" && fileName[index]?.length == rule.allowedCharacters;
      const numberCondition = rule.type == "number" && fileName[index]?.length == rule.allowedCharacters;
      const selectCondition = rule.type == "single select" && rule.options?.includes(fileName[index]);

      if (textCondition || numberCondition || selectCondition) {
        output = true;
      }
      return output;
    });
  }
  return true;
};

export type fileUpgradeArgs = {
  resourceType: string;
  sourceFileVersions?: sourceFileArgs[];
  conversionStatus?: string;
  cachingStatus?: string;
};

export type sourceFileArgs = {
  conversionStatus: string;
  cachingStatus: string;
};

export const isFileVersionUpgradePossible = ({
  resourceType,
  sourceFileVersions,
  conversionStatus,
  cachingStatus,
}: fileUpgradeArgs): boolean => {
  let isUpgardePossibe = true;
  if (resourceType == "RESOURCE_TYPE_MERGED_FILE" && sourceFileVersions) {
    sourceFileVersions.forEach((file: { conversionStatus?: string; cachingStatus?: string }) => {
      if (
        (file.cachingStatus && !["COMPLETED", "NOT_REQUIRED"].includes(file.cachingStatus)) ||
        (file.conversionStatus && !["COMPLETED", "NOT_REQUIRED"].includes(file.conversionStatus))
      ) {
        isUpgardePossibe = false;
      }
    });
  } else if (
    (cachingStatus && !["COMPLETED", "NOT_REQUIRED"].includes(cachingStatus)) ||
    (conversionStatus && !["COMPLETED", "NOT_REQUIRED"].includes(conversionStatus))
  ) {
    isUpgardePossibe = false;
  }

  return isUpgardePossibe;
};

export function updateUnits(props = {}, unitsNew, portalUnits) {
  const lengthsArray = [
    "Length",
    "Width",
    "Height",
    "Thickness",
    "Elevation",
    "Perimeter",
    "Offset",
    "Depth",
    "Distance",
    "Spacing",
  ];

  if (!props || typeof props !== "object") return {};

  const extractSymbol = (str) => {
    const match = str?.match(/.*\(([^)]+)\)/);
    return match?.[1] || null;
  };

  const unitFactors = {};
  [...portalUnits.linearUnits, ...portalUnits.areaUnits, ...portalUnits.volumeUnits].forEach((portalUnit) => {
    const symbol = extractSymbol(portalUnit.unit);
    if (symbol) unitFactors[symbol] = portalUnit.factor;
  });

  const units = {};
  const linearUnit = get(unitsNew, "linearUnit");
  const areaUnit = get(unitsNew, "areaUnit");
  const volumeUnit = get(unitsNew, "volumeUnit");

  if (linearUnit) units.linearUnit = extractSymbol(linearUnit);
  if (areaUnit) units.areaUnit = extractSymbol(areaUnit);
  if (volumeUnit) units.volumeUnit = extractSymbol(volumeUnit);

  return Object.fromEntries(
    Object.entries(props).map(([key, value]) => {
      if (typeof value !== "string") return [key, value];

      let newUnit = null;
      const [numberPart, unit] = value.split(" ");
      const val = Number(numberPart);

      if (key.includes("CUBE Area") && unitFactors[unit] && units.areaUnit && unitFactors[units.areaUnit]) {
        const valueInMM = val * unitFactors[unit];
        const newValue = valueInMM / unitFactors[units.areaUnit];
        return [key, `${newValue} ${units.areaUnit}`];
      } else if (
        key.includes("CUBE Volume") &&
        unitFactors[unit] &&
        units.volumeUnit &&
        unitFactors[units.volumeUnit]
      ) {
        const valueInMM = val * unitFactors[unit];
        const newValue = valueInMM / unitFactors[units.volumeUnit];
        return [key, `${newValue} ${units.volumeUnit}`];
      } else if (lengthsArray.some((field) => key.includes(field))) {
        newUnit = units.linearUnit;
        return newUnit ? [key, `${val} ${newUnit}`] : [key, value];
      } else if (key.includes("Area")) {
        newUnit = units.areaUnit;
        return newUnit ? [key, `${val} ${newUnit}`] : [key, value];
      } else if (key.includes("Volume")) {
        newUnit = units.volumeUnit;
        return newUnit ? [key, `${val} ${newUnit}`] : [key, value];
      }

      return [key, value];
    }),
  );
}

export const getIsViewerDependencyLoaded = ({
  isModelStructureReady,
  isSettingsApplied,
  viewerImpl,
  hwv,
}: {
  isModelStructureReady: boolean;
  isSettingsApplied: boolean;
  viewerImpl: any;
  hwv: any;
}) => {
  return isModelStructureReady && isSettingsApplied && viewerImpl.hwv && hwv;
};
